
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';

export default function About() {
  const handleContactClick = () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}>
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('https://images.canalrealty.us/Hero%20Photos/hero-dc-wide.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-6 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">About Canal Realty</h1>
          <p className="text-xl md:text-2xl">Four Decades of Excellence in Development</p>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Story</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  Founded in 1983, Canal Realty began as a vision to improve communities in metropolitan Washington, DC through thoughtful real estate development. Over four decades, we've built our reputation on integrity, creativity, and excellence. From our first land development to today's complex vertical projects, we've remained committed to creating spaces that enhance communities and deliver lasting value to our tenants and partners.
                </p>
                <p>
                  Our journey has been marked by meaningful partnerships and a steadfast commitment to giving our tenants and partners the energy and attention they deserve. Today, Canal Realty continues to contribute to the landscape of Washington/Baltimore and beyond, always with an eye toward the future.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              Our Mission &amp; Values
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We are driven by a commitment to excellence, innovation, and community impact in everything we do.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-[#9B1F3A] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-building-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Excellence</h3>
              <p className="text-gray-600 leading-relaxed">
                We pursue the highest standards in design, construction, and service, ensuring every project exceeds expectations and stands the test of time.
              </p>
            </div>

            <div className="bg-white p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-[#9B1F3A] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Creativity</h3>
              <p className="text-gray-600 leading-relaxed">
                We embrace new technologies, sustainable practices, and creative solutions to deliver developments that look ahead.
              </p>
            </div>

            <div className="bg-white p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-[#9B1F3A] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-community-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Community</h3>
              <p className="text-gray-600 leading-relaxed">
                We believe great developments strengthen communities, creating spaces where people can live, work, and thrive together.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              Leadership
            </h2>
          </div>
          
          <div className="flex justify-center">
            <div className="bg-gray-50 p-8 shadow-lg max-w-md w-full">
              <div className="mb-6 select-none pointer-events-none">
                <img 
                  src="https://images.canalrealty.us/People/people-kah.jpeg"
                  alt="Kevin A. Hollins - President &amp; CEO"
                  className="w-full h-80 object-cover object-top"
                  draggable="false"
                  onContextMenu={(e) => e.preventDefault()}
                  style={{ userSelect: 'none', pointerEvents: 'none' }}
                  onError={(e) => {
                    e.currentTarget.src = 'https://via.placeholder.com/400x500/f3f4f6/6b7280?text=Kevin+A.+Hollins%0APresident+%26+CEO';
                  }}
                />
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Kevin A. Hollins</h3>
              <p className="text-[#9B1F3A] font-semibold mb-4">President &amp; CEO</p>
              <p className="text-gray-600 leading-relaxed">
                With three decades of experience in real estate development and acquisitions, Kevin has led Canal Realty through decades of growth and innovation. His vision and commitment to excellence have shaped the company's reputation as a trusted partner in creating exceptional projects.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Company Stats */}
      <section className="py-20 bg-[#9B1F3A] text-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Our Impact
            </h2>
            <p className="text-xl max-w-3xl mx-auto">
              Four decades of development excellence reflected in numbers that matter.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl md:text-5xl font-bold mb-2">75+</div>
              <div className="text-lg">Projects Completed</div>
              <div className="text-sm text-white/80 mt-2">Across all property types</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold mb-2">40+</div>
              <div className="text-lg">Years Experience</div>
              <div className="text-sm text-white/80 mt-2">Since our founding</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold mb-2">2M+</div>
              <div className="text-lg">Square Feet Developed</div>
              <div className="text-sm text-white/80 mt-2">Commercial &amp; residential</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold mb-2">175+</div>
              <div className="text-lg">Acres Developed</div>
              <div className="text-sm text-white/80 mt-2">Land development projects</div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Ready to Work Together?
          </h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Whether you're looking for development opportunities, investment partnerships, or have a project in mind, we'd love to hear from you.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" onClick={handleContactClick}>
              <Button size="lg" className="text-lg">
                Contact Us Today
              </Button>
            </Link>
            <Link to="/investor-portal">
              <Button variant="outline" size="lg" className="text-lg">
                Investor Portal
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
